import React from 'react';
import img1 from '../../images/Screenshot (65).png'
import img2 from '../../images/Screenshot (100).png'
import img3 from '../../images/Screenshot (101).png'
import img4 from '../../images/Screenshot (102).png'
import img5 from '../../images/Screenshot (103).png'

const Programmingsensei = () => {
    return (
        <div className='md:m-10 m-4'>
            <div className='md:w-1/2 mx-auto md:my-16'>
                <h1 className='text-4xl font-bold mb-5'>Description</h1>
                <p className='text-lg'>An educational website where you can learn about multiple programming languages through different courses. You must login to buy a course. Also you can read some blogs. I've used JavaScript, React JS, Tailwind, Firebase to develop this project.</p>
                <a href="https://programming-sensei.web.app/" target='blank'>
                    <button className='px-6 py-2 rounded-3xl mt-6 mb-10 md:mt-10 git-button'>Website</button>
                </a>
            </div>
            <div className='grid grid-cols-1 md:grid-cols-2 gap-8'>
                <img src={img1} alt="" className='rounded-xl shadow-xl' />
                <img src={img2} alt="" className='rounded-xl shadow-xl' />
                <img src={img3} alt="" className='rounded-xl shadow-xl' />
                <img src={img4} alt="" className='rounded-xl shadow-xl' />
                <img src={img5} alt="" className='rounded-xl shadow-xl' />
            </div>
        </div>
    );
};

export default Programmingsensei;